import infoIcon from '@/../wwwroot/images/icons/info.svg';
import { R } from '@/features/profile/ProfileResources.resx';
import { Button } from '@/components/Button';
import * as React from 'react';
import { Utils } from '@/shared/Utils';
import { FormErrorText } from '@/components';

type ModulusWarningProps = {
    cprNumber: string;
    onConfirm: () => void;
    onBack: () => void;
    isPending: boolean;
    errorMessage?: string;
};

export const ModulusWarning = ({
    cprNumber,
    onConfirm,
    onBack,
    isPending,
    errorMessage,
}: ModulusWarningProps) => {
    return (
        <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-grey-300 bg-grey-100 p-4">
            <img
                id="edit-action"
                className="text-primary"
                width="24"
                height="24"
                src={infoIcon}
                alt={''}
            />
            <main>
                <p className="mt-1 font-bold">{R.ConfirmCprIsCorrectHeader}</p>
                <p className="text-grey-900">
                    <span>{`${Utils.formatCpr(cprNumber)} `}</span>
                    {R.CprModulusCheckWarning}
                </p>

                {!!errorMessage && <FormErrorText message={errorMessage} />}
            </main>

            <div className="flex justify-end gap-4">
                <Button variant="secondary" outline={false} onClick={onBack}>
                    {R.Back}
                </Button>
                <Button
                    variant="primary"
                    className={isPending ? 'button--loading' : ''}
                    outline={false}
                    onClick={onConfirm}
                >
                    {R.ConfirmAndSave}
                </Button>
            </div>
        </div>
    );
};
